<template>
  <div>
    <v-list color="transparent">
      <draggable v-model="rideTypesStore" @change="orderChanged">
          <v-list-item
            v-for="(rideType,index) in rideTypesStore"
            :key="rideType.id"
            :class="index % 2 === 0 ? 'grey lighten-2' : 'grey lighten-4'"
          >
            <v-list-item-avatar tile>
              <img :src="rideType.image" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <h3>{{ rideType.name }}</h3>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ rideType.description }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon v-if="rideType.enabled" :color="'green lighten-2'">mdi-check</v-icon>
              <v-icon v-if="!rideType.enabled" :color="'red lighten-2'">mdi-close</v-icon>
            </v-list-item-action>
          </v-list-item>
        <v-divider></v-divider>
      </draggable>
    </v-list>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "RideTypeDispatchOrder",
  components: {
    draggable,
  },
  props: {
    ride_types: Array,
    loading: Boolean,
    loadingCostEstimates: Boolean,
  },
  data: function () {
    return {
      rideTypesStore: [],
    };
  },
  beforeMount: async function () {
    this.rideTypesStore = this.ride_types;
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    edit: function (id) {
      this.$emit("edit", id);
    },
    orderChanged: function () {
      this.$emit("assignmentPriorityUpdated", this.rideTypesStore);
    },
    getTariffName: function (tariff) {
      if (tariff.name) {
        return tariff.name + " Modifier";
      } else {
        return "Base Tariff";
      }
    },
  },
  watch: {
    ride_types: function () {
      this.rideTypesStore = this.ride_types;
    },
    rideTypesStore: function () {},
  },
};
</script>
